import React, { Component } from 'react'
import { Grid } from '@mui/material'

class Reports extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const kedo = this.props.kedo

        return (
            <div className={'mainContainer'}>
                {this.state.deleteItem
                    ? this.renderDeleteForm(this.state.deleteItem)
                    : null}
                <Grid container>
                    <Grid size={12}>
                        <h1>
                            {kedo.t('Your PowerBI reports can be embedded ')}
                        </h1>
                        <iframe
                            title={kedo.t('PowerBI report')}
                            referrerPolicy="no-referrer-when-downgrade"
                            width="100%"
                            height="800"
                            frameBorder="0"
                            src="https://app.powerbi.com/view?r=eyJrIjoiM2U5YTE2ZDMtNmNlMS00MTlhLTk3MmYtZTY0Zjc2YTEwZmY4IiwidCI6IjdlY2M4YWEwLTgzMGUtNGQ4Ni1hZjc4LTgzYTNkY2MyNjIzOCIsImMiOjZ9"
                        ></iframe>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default Reports
